module.exports = __webpack_public_path__ + "img/faq14.5b3d330b.png";